(function() {
   "use strict";

   // ==========================================================================
   // CONFIG — EDIT THIS SECTION. (No need to change anything below it.)
   // ==========================================================================

   // This asset should only be loaded for Shopify's US localization.
   // Keep a JS guard as a second line of defense if the include changes later.
   if (!window.SneakerSouqqCheckout || window.SneakerSouqqCheckout.boltEnabled !== true) {
       return;
   }

   const BOLT_BUTTON_SELECTOR = '[data-tid*="instant-bolt-checkout-button"]';
   const ANY_BOLT_BUTTON_SELECTOR = '[data-tid*="bolt-checkout-button"], .bolt-checkout-button';
   const PRODUCT_CHECKOUT_BUTTON_SELECTOR = 'shopify-accelerated-checkout, .shopify-payment-button__button';
   const DYNAMIC_ELEMENTS_SELECTOR = "AOV-CDMinimal, #AOV-CDMinimal";
   const CART_TOKEN_COOKIE_NAME = "cart";

   // PDP form lookup improvements from the Oct 6 Bolt theme update.
   // Specific selectors are safe on any page (quick-add modals / featured product sections).
   // Generic add-to-cart selectors are only used on true product pages so collection-card
   // forms cannot be mistaken for the Buy It Now product.
   const PDP_FORM_SELECTORS = [
       "quick-add-modal[open] form[action*='/cart/add']",
       "quick-add-modal[open] form[data-type=add-to-cart-form]",
       "form[data-type=add-to-cart-form]",
   ];
   const GENERIC_PDP_FORM_SELECTORS = [
       "product-form form[action*='/cart/add']",
       "form[action*='/cart/add'][id^='product-form']:not([id*='installment']):not(.installment)",
       "form[action*='/cart/add']:not([id*='installment']):not(.installment)",
   ];

   // --- Optional. Pre-populate the shopper's information. -------------------
   const hints = {
       // prefill: {
       //   firstName: "Bolt",
       //   lastName: "User",
       //   email: "email@example.com",
       //   phone: "1112223333",
       //   addressLine1: "1235 Howard St",
       //   addressLine2: "Unit D",
       //   city: "San Francisco",
       //   state: "California",
       //   zip: "94103",
       //   country: "US", // ISO Alpha-2
       // },
   };

   function centsToDollars(cents) {
       return cents === undefined || cents === null ? undefined : cents / 100;
   }

   async function fetchShopifyCart() {
       const response = await fetch(window.Shopify.routes.root + "cart.js");
       if (!response.ok) {
           throw new Error("Error fetching Shopify cart: " + (await response.text()));
       }
       return response.json();
   }

   async function getCartToken() {
       let encodedToken;
       if (window.cookieStore) {
           const cookie = await window.cookieStore.get(CART_TOKEN_COOKIE_NAME);
           encodedToken = cookie && cookie.value;
       } else {
           const row = document.cookie.split("; ").find(function(r) {
               return r.indexOf(CART_TOKEN_COOKIE_NAME + "=") === 0;
           });
           encodedToken = row ? row.split("=")[1] : undefined;
       }
       if (encodedToken) {
           return decodeURIComponent(encodedToken);
       }
       const cart = await fetchShopifyCart();
       return cart.token;
   }

   async function clearCart() {
       if (window.cookieStore) {
           await window.cookieStore.delete(CART_TOKEN_COOKIE_NAME);
           return;
       }
       document.cookie = CART_TOKEN_COOKIE_NAME + "=; path=/; expires=" + new Date(0).toUTCString();
   }

   function isProductPage() {
       const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
       if (meta && meta.page && meta.page.pageType) {
           return meta.page.pageType === "product";
       }
       return /\/products\//.test(location.pathname);
   }

   function findPdpForm(trigger) {
       // First prefer the exact product-form that contains the clicked native Buy It Now
       // button. This preserves V18's selected-product behavior when multiple product forms
       // exist on the page.
       if (trigger && trigger.closest) {
           const productFormElement = trigger.closest("product-form");
           if (productFormElement) {
               const localForm = productFormElement.querySelector("form[action*='/cart/add'], form");
               if (localForm) return localForm;
           }

           const localForm = trigger.closest("form[action*='/cart/add']");
           if (localForm) return localForm;
       }

       const selectors = PDP_FORM_SELECTORS.concat(isProductPage() ? GENERIC_PDP_FORM_SELECTORS : []);
       for (const selector of selectors) {
           const form = document.querySelector(selector);
           if (form) return form;
       }
       return null;
   }

   function getSelectedVariantId(form) {
       // Read the live variant control directly. FormData ignores disabled controls,
       // while many Shopify themes temporarily disable the variant input during updates.
       const formId = form.getAttribute("id");
       let externalInput = null;

       if (formId) {
           try {
               externalInput = document.querySelector(
                   "[name='id'][form='" + CSS.escape(formId) + "']"
               );
           } catch (e) {
               // CSS.escape is widely supported, but keep the checkout resilient if a
               // browser or unusual form ID makes this selector unavailable.
               externalInput = document.querySelector("[name='id'][form=\"" + formId.replace(/\"/g, "\\\"") + "\"]");
           }
       }

       const input = form.querySelector("[name='id']") || externalInput;
       if (input && input.value) return String(input.value);

       // Never use page-level variant fallbacks for quick-add/modal forms because they
       // could refer to the main PDP instead of the modal product.
       if (form.closest("quick-add-modal, [role='dialog']")) return null;

       const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
       return (
           new URLSearchParams(location.search).get("variant") ||
           (meta && meta.selectedVariantId ? String(meta.selectedVariantId) : null)
       );
   }

   function getPdpInfo(trigger) {
       const form = findPdpForm(trigger);
       if (!form) {
           throw new Error("PDP Info form not found");
       }

       const variantId = getSelectedVariantId(form);
       const quantityInput = form.querySelector('[name="quantity"]');
       const quantity = Math.max(1, Number(quantityInput && quantityInput.value ? quantityInput.value : 1) || 1);

       if (!variantId) {
           throw new Error("Selected variant ID not found");
       }

       return {
           variantId: String(variantId),
           quantity: quantity,
       };
   }

   function debounce(func, delay) {
       let timeout;
       return function() {
           const args = [].slice.call(arguments);
           clearTimeout(timeout);
           timeout = setTimeout(function() {
               func.apply(null, args);
           }, delay);
       };
   }

   function mapShopifyCartToKlaviyoCheckout(cart) {
       const lineItems = (cart.items || []).map(function(item) {
           return {
               key: item.key,
               sku: item.sku,
               title: item.title,
               taxable: item.taxable,
               gift_card: item.gift_card,
               line_price_set: {
                   shop_money: { amount: centsToDollars(item.price) },
                   presentment_money: { amount: item.presentment_price },
               },
               grams: item.grams,
               line_price: centsToDollars(item.line_price),
               product_id: item.product_id,
               variant_id: item.variant_id,
               variant_price: centsToDollars(item.price),
               variant_title: item.variant_title || undefined,
               vendor: item.vendor,
               quantity: item.quantity,
               price: centsToDollars(item.price),
               properties: item.properties,
               applied_discounts: item.discounts,
               requires_shipping: item.requires_shipping,
               product: {
                   handle: item.handle,
                   id: item.product_id,
                   title: item.product_title,
                   product_type: item.product_type,
                   vendor: item.vendor,
                   images: item.featured_image
                       ? [Object.assign({ src: item.featured_image.url }, item.featured_image)]
                       : [],
               },
           };
       });

       return {
           "Source Name": "Bolt Managed Checkout",
           "$value": centsToDollars(cart.total_price),
           "Customer Locale": navigator.language,
           "Collections": [],
           "Total Discounts": centsToDollars(cart.total_discount),
           "Discount Codes": (cart.discount_codes || [])
               .filter(function(d) { return d.applicable; })
               .map(function(d) { return d.code; }),
           "Item Count": cart.item_count,
           "Items": (cart.items || []).map(function(item) { return item.title; }),
           "extra": {
               "referring_site": document.referrer,
               // Only forward the public part of the token; the key is a secret.
               "token": cart.token.split("?")[0],
               "line_items": lineItems,
               "presentment_currency": cart.currency,
               "note_attributes": Object.entries(cart.attributes || {}).map(function(entry) {
                   return { name: entry[0], value: entry[1] };
               }),
           },
       };
   }

function isInsideBoltButton(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(ANY_BOLT_BUTTON_SELECTOR);
}

function isVisibleElement(element) {
    if (!element || element.nodeType !== 1) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0";
}

function normalizedElementText(element) {
    return ((element && (element.innerText || element.textContent || element.value)) || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
}

function elementLooksLikeCheckout(element) {
    if (!element || element.nodeType !== 1) return false;
    if (isInsideBoltButton(element) || element.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return false;

    const text = normalizedElementText(element);
    const name = (element.getAttribute("name") || "").toLowerCase();
    const href = (element.getAttribute("href") || "").toLowerCase();
    const aria = (element.getAttribute("aria-label") || "").toLowerCase();
    const dataAction = (element.getAttribute("data-action") || "").toLowerCase();
    const idAndClass = ((element.id || "") + " " + (typeof element.className === "string" ? element.className : "")).toLowerCase();

    return (
        text === "checkout" ||
        (text.indexOf("checkout") !== -1 && text.length <= 40) ||
        name === "checkout" ||
        aria.indexOf("checkout") !== -1 ||
        dataAction.indexOf("checkout") !== -1 ||
        idAndClass.indexOf("checkout") !== -1 ||
        /\/checkout(?:[/?#]|$)/.test(href)
    );
}

function findCheckoutShell(element, root) {
    let current = element;
    let fallback = null;

    for (let depth = 0; current && current !== root && depth < 7; depth += 1, current = current.parentElement) {
        if (isInsideBoltButton(current) || current.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return null;
        if (!isVisibleElement(current)) continue;

        const rect = current.getBoundingClientRect();
        const tag = current.tagName ? current.tagName.toLowerCase() : "";
        const role = (current.getAttribute("role") || "").toLowerCase();
        const idAndClass = ((current.id || "") + " " + (typeof current.className === "string" ? current.className : "")).toLowerCase();
        const style = window.getComputedStyle(current);
        const semanticButton = tag === "button" || tag === "a" || tag === "input" || role === "button";
        const namedButton = /checkout|button|btn|cta/.test(idAndClass);
        const visualButton = rect.width >= 120 && rect.height >= 32 && rect.height <= 110 && style.cursor === "pointer";

        if (semanticButton || namedButton || visualButton) return current;
        if (!fallback && rect.width >= 120 && rect.height >= 32 && rect.height <= 110) fallback = current;
    }

    return fallback || element;
}

function hideBoltPresentation(button) {
    if (!button || button.dataset.ssqHiddenBoltButton === "true") return;

    let shell = button;
    let current = button.parentElement;
    for (let depth = 0; current && depth < 3; depth += 1, current = current.parentElement) {
        if (current.matches && current.matches(DYNAMIC_ELEMENTS_SELECTOR)) break;
        if (!current.querySelector || !current.querySelector(ANY_BOLT_BUTTON_SELECTOR)) break;

        const text = normalizedElementText(current);
        const rect = current.getBoundingClientRect();
        const otherCheckout = Array.from(current.querySelectorAll('button, a, [role="button"], input[type="submit"], input[type="button"]')).some(function(candidate) {
            return !isInsideBoltButton(candidate) && elementLooksLikeCheckout(candidate);
        });

        if (!otherCheckout && text.indexOf("checkout") !== -1 && rect.height <= 140) {
            shell = current;
        } else {
            break;
        }
    }

    shell.dataset.ssqHiddenBoltButton = "true";
    shell.style.setProperty("display", "none", "important");
    shell.setAttribute("aria-hidden", "true");
}

function getAovRoots() {
    const roots = [];
    document.querySelectorAll(DYNAMIC_ELEMENTS_SELECTOR).forEach(function(root) {
        roots.push(root);
        if (root.shadowRoot) roots.push(root.shadowRoot);
    });
    return roots;
}

function hideInjectedAovBoltButton() {
    const roots = getAovRoots();
    if (!roots.length) return;

    roots.forEach(function(root) {
        const buttons = root.querySelectorAll(ANY_BOLT_BUTTON_SELECTOR + ", " + BOLT_BUTTON_SELECTOR);
        buttons.forEach(hideBoltPresentation);
    });
}

function isExplicitAovCheckoutControl(element) {
    if (!element || !(element instanceof Element)) return false;
    if (isInsideBoltButton(element) || element.querySelector(ANY_BOLT_BUTTON_SELECTOR)) return false;

    const tag = (element.tagName || "").toLowerCase();
    const role = (element.getAttribute("role") || "").toLowerCase();
    const type = (element.getAttribute("type") || "").toLowerCase();
    const name = (element.getAttribute("name") || "").toLowerCase();
    const href = (element.getAttribute("href") || "").toLowerCase();
    const aria = (element.getAttribute("aria-label") || "").toLowerCase();
    const dataAction = (element.getAttribute("data-action") || "").toLowerCase();
    const text = normalizedElementText(element);

    const interactive =
        tag === "button" ||
        tag === "a" ||
        tag === "input" ||
        role === "button" ||
        type === "submit";

    if (!interactive) return false;

    return (
        name === "checkout" ||
        dataAction === "checkout" ||
        /\/checkout(?:[/?#]|$)/.test(href) ||
        aria === "checkout" ||
        text === "checkout"
    );
}

function getClickedAovCheckout(target, event) {
    const roots = getAovRoots();
    if (!roots.length || !target) return null;

    const path = event && typeof event.composedPath === "function" ? event.composedPath() : [];
    const insideAov = roots.some(function(root) {
        const host = root instanceof ShadowRoot ? root.host : root;
        return host === target || (host.contains && host.contains(target)) || path.indexOf(host) !== -1;
    });
    if (!insideAov) return null;

    // Only intercept the actual AOV checkout control. Do not walk arbitrary
    // checkout-named ancestors: Bolt's mobile full-screen checkout can be
    // mounted inside the AOV custom element, and field taps must pass through.
    for (const node of path) {
        if (!(node instanceof Element)) continue;
        if (isInsideBoltButton(node)) return null;
        if (isExplicitAovCheckoutControl(node)) return node;
    }

    let current = target.nodeType === 1 ? target : target.parentElement;
    for (let depth = 0; current && depth < 3; depth += 1, current = current.parentElement) {
        if (isInsideBoltButton(current)) return null;
        if (isExplicitAovCheckoutControl(current)) return current;
    }

    return null;
}

function configureDynamicElements(selector, builtCallbacks) {
    const debouncedDedupe = debounce(hideInjectedAovBoltButton, 60);

    // Mobile Bolt renders a full-screen checkout inside the storefront document.
    // Never call BoltCheckout.configure() from DOM mutations: doing so while that
    // checkout is open can tear down the active session. Mutations are used only
    // to hide Bolt's extra button when it is actually nested inside the AOV cart.
    const observer = new MutationObserver(function(mutations) {
        if (boltCheckoutActive) return;
        let changedInsideAov = false;

        for (const mutation of mutations) {
            const target = mutation.target;
            if (!(target instanceof Element)) continue;

            if (target.matches(DYNAMIC_ELEMENTS_SELECTOR) || target.closest(DYNAMIC_ELEMENTS_SELECTOR)) {
                changedInsideAov = true;
                break;
            }
        }

        if (changedInsideAov) debouncedDedupe();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    log("Watching AOV cart mutations only; Bolt will not be reconfigured from DOM changes");

    // Run once for an AOV drawer that is already rendered.
    debouncedDedupe();
}


   // --- Optional checkout lifecycle hooks. -----------------------------------
   // Bolt uses the Shopify cart token as the checkout/order reference. Because
   // this integration creates Shopify orders through Bolt rather than Shopify's
   // native checkout, Shopify does not automatically rotate that cart token.
   // Clear it only after a successful Bolt payment so the next checkout gets a
   // fresh order reference. Bolt's hosted confirmation page remains in control
   // after callback() is invoked.
   const callbacks = {
       success: async function(transaction, callback) {
           try {
               await clearCart();
           } catch (e) {
               console.error(LOG_PREFIX, "Error clearing cart after successful Bolt checkout:", e);
           }
           callback();
       },

       // check: function () { return true; },   // must return a boolean
       // onCheckoutStart: function () {},
       // onEmailEnter: function (email) {},
       // onShippingDetailsComplete: function (address) {},
       // onShippingOptionsComplete: function () {},
       // onPaymentSubmit: function () {},
       // close: function () {},
   };

   // --- Analytics. Toggle the tools you use. --------------------------------
   // Each is also skipped automatically if the tool is not detected on the page.
   const analytics = {
       klaviyo: true,
       northbeam: true,
       google: true, // gtag() and/or window.dataLayer
   };

   // Rich Klaviyo payload, plus generic value/currency/items for Google.
   async function getCheckoutData() {
       try {
           const cart = await fetchShopifyCart();
           const data = mapShopifyCartToKlaviyoCheckout(cart);
           data.$value = centsToDollars(cart.total_price);
           data.currency = cart.currency;
           data.Items = (cart.items || []).map(function(item) {
               return {
                   id: item.sku || item.product_id,
                   name: item.title,
                   price: centsToDollars(item.price),
                   quantity: item.quantity,
               };
           });
           return data;
       } catch (e) {
           console.error(LOG_PREFIX, "Error fetching checkout data:", e);
           return null;
       }
   }

   // Set to true to log every checkout event + emitted analytics to the console.
   var debug = false;

   // ==========================================================================
   // END CONFIG — you do not need to edit anything below this line.
   // ==========================================================================

   var LOG_PREFIX = "[Bolt Checkout]";

   function log() {
       if (debug) {
           console.debug.apply(console, [LOG_PREFIX].concat([].slice.call(arguments)));
       }
   }

   // Run something best-effort. A failing hook (analytics or merchant) must
   // never block or break checkout.
   function safely(name, fn, args) {
       if (typeof fn !== "function") {
           return undefined;
       }
       try {
           return fn.apply(null, args || []);
       } catch (e) {
           console.error(LOG_PREFIX, "Error in '" + name + "':", e);
           return undefined;
       }
   }

   async function getData() {
       return (await safely("getCheckoutData", getCheckoutData)) || null;
   }

   // --------------------------------------------------------------------------
   // Analytics emitters — each is a no-op if the tool is disabled or absent.
   // --------------------------------------------------------------------------
   function klaviyoTrack(event, properties) {
       if (analytics.klaviyo && window.klaviyo && typeof window.klaviyo.track === "function") {
           log("klaviyo track", event, properties);
           safely("klaviyo.track", function() { window.klaviyo.track(event, properties || {}); });
       }
   }

   function klaviyoIdentify(properties) {
       if (analytics.klaviyo && window.klaviyo && typeof window.klaviyo.identify === "function") {
           log("klaviyo identify", properties);
           safely("klaviyo.identify", function() { window.klaviyo.identify(properties || {}); });
       }
   }

   function northbeamIdentifyEmail(email) {
       if (analytics.northbeam && window.Northbeam && typeof window.Northbeam.identify === "function") {
           log("northbeam identify", email);
           safely("Northbeam.identify", function() { window.Northbeam.identify("email", email); });
       }
   }

   function googleEvent(eventName, params) {
       if (!analytics.google) {
           return;
       }
       if (typeof window.gtag === "function") {
           log("gtag", eventName, params);
           safely("gtag", function() { window.gtag("event", eventName, params || {}); });
       } else if (Array.isArray(window.dataLayer)) {
           log("dataLayer", eventName, params);
           safely("dataLayer", function() { window.dataLayer.push(Object.assign({ event: eventName }, params || {})); });
       }
   }

   // Map our generic checkout data into a Google ecommerce payload.
   function toGoogleEcommerce(data) {
       if (!data) {
           return {};
       }
       return {
           currency: data.currency,
           value: data.value,
           items: (data.items || []).map(function(item) {
               return {
                   item_id: item.id || item.sku,
                   item_name: item.name || item.title,
                   price: item.price,
                   quantity: item.quantity,
               };
           }),
       };
   }

   // Built-in analytics for each lifecycle event (runs before the merchant's
   // own hook of the same name).
   var emit = {
       onCheckoutStart: async function() {
           const data = await getData();
           klaviyoTrack("Checkout Started", data || {});
           googleEvent("begin_checkout", toGoogleEcommerce(data));
       },
       onEmailEnter: function(email) {
           if (!email) {
               return;
           }
           klaviyoIdentify({ email: email });
           northbeamIdentifyEmail(email);
       },
       onShippingDetailsComplete: function(address) {
           if (address) {
               klaviyoIdentify(address);
           }
       },
       onPaymentSubmit: async function() {
           googleEvent("add_payment_info", toGoogleEcommerce(await getData()));
       },
       onSuccess: async function(transaction) {
           googleEvent("purchase", Object.assign(
               { transaction_id: transaction && (transaction.reference || transaction.id) },
               toGoogleEcommerce(await getData())
           ));
       },
   };

   // --------------------------------------------------------------------------
   // Build the callbacks object passed to Bolt: analytics first, then the
   // merchant's own hook. The two contractual callbacks are handled explicitly:
   //   - check   must return a boolean (defaults to allowing checkout)
   //   - success must invoke its callback (guaranteed even on error)
   // --------------------------------------------------------------------------

   // Compose an analytics emitter with the merchant's optional hook into one
   // callback. Logs and is crash-isolated.
   function combine(name, emitFn) {
       var merchantFn = callbacks ? callbacks[name] : undefined;
       return function() {
           var args = [].slice.call(arguments);
           log(name, args);
           safely(name + " (analytics)", emitFn, args);
           safely(name + " (merchant)", merchantFn, args);
       };
   }

   function buildCallbacks() {
       var merchant = callbacks || {};

       return {
           check: function() {
               log("check");
               if (typeof merchant.check === "function") {
                   return safely("check", merchant.check, [].slice.call(arguments)) !== false;
               }
               return true;
           },

           onCheckoutStart: combine("onCheckoutStart", emit.onCheckoutStart),
           onEmailEnter: combine("onEmailEnter", emit.onEmailEnter),
           onShippingDetailsComplete: combine("onShippingDetailsComplete", emit.onShippingDetailsComplete),
           onShippingOptionsComplete: combine("onShippingOptionsComplete", null),
           onPaymentSubmit: combine("onPaymentSubmit", emit.onPaymentSubmit),
           close: function() {
               boltCheckoutActive = false;
               var result = combine("close", null).apply(this, arguments);

               // If the shopper manually exits Bolt, return them to the page
               // where they launched checkout instead of falling through to
               // Shopify's native /checkout. Do not interfere with Bolt's
               // post-payment completion/redirect after a successful order.
               if (!boltCheckoutCompleted && boltCheckoutReturnUrl) {
                   window.location.assign(boltCheckoutReturnUrl);
               }

               return result;
           },

           success: function(transaction, callback) {
               boltCheckoutCompleted = true;
               log("success", transaction);
               safely("success (analytics)", emit.onSuccess, [transaction]);

               var called = false;
               var safeCallback = function() {
                   if (called) return;
                   called = true;
                   if (typeof callback === "function") callback();
               };

               if (typeof merchant.success !== "function") {
                   safeCallback();
                   return;
               }

               try {
                   var maybePromise = merchant.success(transaction, safeCallback);
                   if (maybePromise && typeof maybePromise.then === "function") {
                       maybePromise.then(safeCallback, function(e) {
                           console.error(LOG_PREFIX, "Error in async 'success' callback:", e);
                           safeCallback();
                       });
                   }
               } catch (e) {
                   console.error(LOG_PREFIX, "Error in 'success' callback:", e);
                   safeCallback();
               }
           },

       };
   }

   function isBoltReady(method) {
       if (!window.BoltCheckout || typeof window.BoltCheckout[method] !== "function") {
           console.error(
               LOG_PREFIX,
               "BoltCheckout." + method + " is not available. Ensure Bolt's connect.js is loaded before this snippet."
           );
           return false;
       }
       return true;
   }

   // --------------------------------------------------------------------------
   // Use one Bolt cart checkout flow everywhere. On the product page, the
   // native Shopify Buy It Now button is intercepted, the currently selected
   // variant/quantity is added to the existing cart, and that full cart is
   // opened in Bolt. This avoids Bolt product-checkout reconfiguration closing
   // an already-open checkout.
   // --------------------------------------------------------------------------
   var cartCheckoutHandle = null;
   var activeCallbacks = null;
   var productCheckoutInProgress = false;
   var boltCheckoutActive = false;
   var boltCheckoutCompleted = false;
   var boltCheckoutReturnUrl = null;

   function setCartCheckoutHandle(handle) {
       cartCheckoutHandle = handle;
   }

   async function configureCartCheckout() {
       if (!isBoltReady("configure")) return null;
       try {
           const cartToken = await getCartToken();
           const result = await Promise.resolve(
               window.BoltCheckout.configure({ id: cartToken }, hints || {}, activeCallbacks || buildCallbacks())
           );
           setCartCheckoutHandle(result);
           return result;
       } catch (e) {
           console.error(LOG_PREFIX, "Error configuring cart checkout:", e);
           return null;
       }
   }

   function openHandle(handle, name) {
       if (!handle || typeof handle.open !== "function") return false;
       try {
           boltCheckoutReturnUrl = window.location.href;
           boltCheckoutCompleted = false;
           boltCheckoutActive = true;
           handle.open();
           return true;
       } catch (e) {
           boltCheckoutActive = false;
           console.error(LOG_PREFIX, "Error opening " + name + ":", e);
           return false;
       }
   }

   async function addSelectedProductToCart(trigger) {
       const pdpInfo = getPdpInfo(trigger);
       const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
               "Accept": "application/json",
           },
           body: JSON.stringify({
               items: [{ id: Number(pdpInfo.variantId), quantity: pdpInfo.quantity }],
           }),
       });

       if (!response.ok) {
           throw new Error("Unable to add selected product to cart: " + (await response.text()));
       }
       return response.json();
   }

   window.BoltOpenCartCheckout = async function() {
       const result = await configureCartCheckout();
       const handle = result || cartCheckoutHandle;
       if (!openHandle(handle, "Bolt cart checkout")) {
           console.error(LOG_PREFIX, "Cart checkout is not configured yet.");
           return false;
       }
       return true;
   };

   window.BoltOpenProductCheckout = async function(trigger) {
       if (productCheckoutInProgress) return false;
       productCheckoutInProgress = true;

       try {
           await addSelectedProductToCart(trigger);

           // Reconfigure only after Shopify confirms the item was added so Bolt
           // receives the current cart: existing items + the Buy It Now item.
           const result = await configureCartCheckout();
           const handle = result || cartCheckoutHandle;

           if (!openHandle(handle, "Bolt cart checkout from Buy It Now")) {
               throw new Error("Bolt cart checkout handle is unavailable.");
           }

           return true;
       } catch (e) {
           console.error(LOG_PREFIX, "Unable to open Bolt from Buy It Now:", e);
           return false;
       } finally {
           productCheckoutInProgress = false;
       }
   };

   document.addEventListener("click", function(event) {
       if (boltCheckoutActive) return;
       const path = typeof event.composedPath === "function" ? event.composedPath() : [event.target];
       let button = null;

       for (const node of path) {
           if (node && node.matches && node.matches(PRODUCT_CHECKOUT_BUTTON_SELECTOR)) {
               button = node;
               break;
           }
       }

       if (!button && event.target && event.target.closest) {
           const paymentContainer = event.target.closest("product-form .shopify-payment-button");
           if (paymentContainer) {
               button = paymentContainer.querySelector(PRODUCT_CHECKOUT_BUTTON_SELECTOR) || paymentContainer;
           }
       }

       if (!button || !button.closest || !button.closest("product-form")) return;
       event.preventDefault();
       event.stopImmediatePropagation();
       if (button.disabled || button.getAttribute("aria-disabled") === "true") return;
       window.BoltOpenProductCheckout(button);
   }, true);

   function findAovHost(element) {
       if (!element) return null;
       if (element.matches && element.matches(DYNAMIC_ELEMENTS_SELECTOR)) return element;
       return element.closest ? element.closest(DYNAMIC_ELEMENTS_SELECTOR) : null;
   }

   function findAovCloseControl(host) {
       if (!host || !host.querySelectorAll) return null;
       const selectors = [
           'button[aria-label*="close" i]',
           '[role="button"][aria-label*="close" i]',
           'button[data-action*="close" i]',
           '[role="button"][data-action*="close" i]',
           'button[class*="close" i]',
           '[role="button"][class*="close" i]'
       ];

       for (const selector of selectors) {
           const candidate = host.querySelector(selector);
           if (candidate && isVisibleElement(candidate) && !isInsideBoltButton(candidate)) return candidate;
       }

       return null;
   }

   async function closeAovBeforeBolt(control) {
       const host = findAovHost(control);
       if (!host) return;

       try {
           if (document.activeElement && typeof document.activeElement.blur === "function") {
               document.activeElement.blur();
           }
       } catch (e) {}

       const closeControl = findAovCloseControl(host);
       if (closeControl) {
           closeControl.click();
           await new Promise(function(resolve) { setTimeout(resolve, 260); });
           return;
       }

       // Fallback for AOV builds whose close control isn't exposed in the light DOM.
       // Hide the drawer before Bolt opens so its mobile focusout logic has already
       // finished and cannot tear down the checkout when an input receives focus.
       host.style.setProperty("display", "none", "important");
       host.setAttribute("aria-hidden", "true");
       await new Promise(function(resolve) { setTimeout(resolve, 80); });
   }

   document.addEventListener("click", async function(event) {
       if (boltCheckoutActive) return;
       const aovCheckout = getClickedAovCheckout(event.target, event);
       if (!aovCheckout) return;
       event.preventDefault();
       event.stopImmediatePropagation();
       await closeAovBeforeBolt(aovCheckout);
       window.BoltOpenCartCheckout();
   }, true);

   async function setup() {
       if (!window.Shopify || !window.Shopify.routes) {
           console.error(LOG_PREFIX, "window.Shopify not found.");
           return;
       }
       if (!isBoltReady("configure")) {
           return;
       }

       activeCallbacks = buildCallbacks();

       const result = await configureCartCheckout();
       if (!result || !result.hasBoltButton) {
           log("No Bolt cart button found yet; AOV may inject it after page load.");
       }

       // Do not dynamically mount Bolt inside AOV. AOV remains only the cart UI;
       // its native checkout button opens the independently configured Bolt checkout.
       hideInjectedAovBoltButton();
   }

   if (document.readyState === "loading") {
       document.addEventListener("DOMContentLoaded", setup);
   } else {
       setup();
   }
})();
